import Vue from 'vue'
import cloneDeep from 'lodash/cloneDeep'
const initState ={

}
export default {
    state: cloneDeep(initState),
    mutations: {
        userResetStore(state){
            if(window.vm.$store.state){
                Vue.set(window.vm.$store.state,'user',cloneDeep(initState))
            }
        },
        updateUser(state, valObj) {
            for (let key in valObj) {
                Vue.set(state,key,valObj[key]);
                // state[key] = valObj[key];
            }
        },
        //在全局中更新：this.$store.commit('update', { step: 2 });
        //在全局中获取：this.$store.state.user.name
    },
    actions: {},
    getters: {}
}
